import { getAllUrlParams, useAPI } from "../../../lib/common";
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "../../hooks/useRoutes";
import useGoogleFonts from "../../SPA/hooks/useGoogleFonts";
import { templateFontList } from "../../SPA/Components/EditTemplateProduct/common";
import useFilteredTemplateList from "../../SPA/hooks/useFilteredTemplateList";
import SubHeader from "../../SPA/Components/SubHeader";
import FiltersDialog from "../../SPA/Components/Template/FiltersDialog";
import useTemplateList from "../../hooks/useTemplateList";
import useTemplateFilters from "../../hooks/useTemplateFilters";
import TypeOptions from "./TypeOptions";
import ProductsWithTemplates from "./ProductsWithTemplates";
export const CardListPageContent = ({ category }) => {
    var _a;
    const [data, loading] = useAPI(`/m/api/templates/cards/categories`);
    const type = "cards";
    const [cat, setCategory] = useState(category);
    const [t] = useTranslation();
    const location = useLocation();
    const [templateList, loadingTemplates] = useTemplateList(type, cat);
    const { loaded: fontsLoaded } = useGoogleFonts(templateFontList);
    // Get params as an object:
    const params = useMemo(() => {
        // Hack to trigger a scroll event (For templates to show)
        window.scrollTo(window.scrollX, window.scrollY - 1);
        window.scrollTo(window.scrollX, window.scrollY + 1);
        return getAllUrlParams(location.search);
    }, [location]);
    const filterOptions = useMemo(() => {
        return {
            filters: ["formats", "texts", "images"],
            predef: params,
        };
    }, [params]);
    const [filters, toggleFilterOption] = useTemplateFilters(templateList, filterOptions);
    const filteredTemplates = useFilteredTemplateList(templateList, filters);
    const [filtersOpen, setFiltersOpen] = useState(false);
    useEffect(() => {
        console.log("Card wrapper", loading, data);
        if (!data) {
            return;
        }
        console.log(">Category", category, data);
        if (category) {
            setCategory(category);
        }
        else {
            setCategory(data.defaultCategory);
        }
    }, [data, category]);
    const handleChangeCategory = (category) => {
        setCategory(category);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(SubHeader, { title: t("Cards"), subtitle: (_a = t("Choose template")) !== null && _a !== void 0 ? _a : "" }),
        React.createElement(TypeOptions, { category: cat, categories: (data === null || data === void 0 ? void 0 : data.categories) || [], handleChangeCategory: handleChangeCategory, setFiltersOpen: setFiltersOpen, filters: filters, toggleFilterOption: toggleFilterOption }),
        React.createElement(ProductsWithTemplates, { loading: loadingTemplates || !fontsLoaded, type: 'card', category: cat, templates: filteredTemplates, canViewWithOwnPictures: true, separateFromBackground: true }),
        filtersOpen && (React.createElement(FiltersDialog, { filters: filters, toggleFilterOption: toggleFilterOption, templates: templateList.templates, filteredTemplates: filteredTemplates, onClose: () => setFiltersOpen(false), onOpen: () => setFiltersOpen(true) }))));
};
